import { useMutation } from '@apollo/client';
import apolloClient from 'src/apollo/sofarApolloClient';

import {
  ChangePasswordData,
  Mobile,
  UpdateUserProfileData,
  User,
} from 'app/shared/typings/users';

import {
  CHANGE_PASSWORD,
  CLAIM_GUEST_USER_ACCOUNT,
  CREATE_GUEST_USER_ACCOUNT,
  UPDATE_USER_HOW_HEARD_ABOUT,
} from './mutations';

export interface ClaimGuestUserAccountVariables {
  claimUserToken: string;
  birthYear?: string;
  firstName?: string;
  lastName?: string;
  mobile?: Mobile;
  optInFanMarketingSmses?: boolean;
  password?: string;
}

export interface ClaimGuestUserAccountData {
  claimGuestUserAccount: {
    success: boolean;
    user: User;
  };
}

export const ClaimGuestUserAccount = () => {
  return useMutation<ClaimGuestUserAccountData>(CLAIM_GUEST_USER_ACCOUNT);
};

export interface CreateGuestUserAccountVariables {
  email: string;
  firstName?: string;
  lastName?: string;
  optInFanMarketingEmails?: boolean;
}

export interface CreateGuestUserAccountData {
  createGuestUserAccount: {
    success: boolean;
    user: User;
  };
}

export const createGuestUserAccount = async (
  variables: CreateGuestUserAccountVariables
) => {
  return apolloClient.mutate<
    CreateGuestUserAccountData,
    CreateGuestUserAccountVariables
  >({ mutation: CREATE_GUEST_USER_ACCOUNT, variables });
};

export const ChangePassword = () => {
  return useMutation<ChangePasswordData>(CHANGE_PASSWORD)[0];
};
export const UpdateUserHowHeardAbout = () => {
  return useMutation<UpdateUserProfileData>(UPDATE_USER_HOW_HEARD_ABOUT)[0];
};
